import React, {memo, useContext} from "react"
import style from "styles/slider.module.css"
import useLocale from '../../../../hooks/useLocale'
import ThemeContext from '../../../../context/themeContext'

const Slider = () => {
	const {visionSlider} = useLocale()

	const { activeVision, setActiveVision, setNumber } = useContext(ThemeContext);

	const handleOnClickOne = () => {
		setNumber(0)
		setActiveVision(!activeVision)
	}
	const handleOnClickTwo = () => {
		setNumber(1)
		setActiveVision(!activeVision)
	}
	const handleOnClickThree = () => {
		setNumber(2)
		setActiveVision(!activeVision)
	}
	const handleOnClickFour = () => {
		setNumber(3)
		setActiveVision(!activeVision)
	}

	return (
		<div
			data-aos-once="true"
			data-aos="fade-up"
			data-aos-offset="100"
			data-aos-easing="ease-in-sine"
			className={style.screenshots}>
			<div className={style.container}>
				<div className={style.title}>{visionSlider.title}</div>
				<div className={style.subtitle}>{visionSlider.subtitle}</div>

				<div className={style.block}>
					<button aria-label="picture 1" onClick={handleOnClickOne} className={style.picture1}>
						<img
							src="/image/vision/screen1.webp"
							alt=""
						/>
					</button>
					<button aria-label="picture 2" onClick={handleOnClickTwo} className={style.picture2}>
						<img
							src="/image/vision/screen2.webp"
							alt=""
						/>
					</button>
					<button aria-label="picture 3" onClick={handleOnClickThree} className={style.picture4}>
						<img
							src="/image/vision/screen3.webp"
							alt=""
						/>
					</button>
					<button aria-label="picture 4" onClick={handleOnClickFour} className={style.picture3}>
						<img
							src="/image/vision/screen4.webp"
							alt=""
						/>
					</button>
				</div>
			</div>

			<div className={style.fade}/>
			<div className={style.fade}/>
		</div>
	)
}

export default memo(Slider)
